import axios from '@utils/axios';

const createEditUser = {
  state: {
    productId: 0,
    name: '',
    price: 0
  },
  mutations: {
    setName(state, name) {
      state.name = name;
    },
    setPrice(state, price) {
      state.price = price;
    },
    setProductTypeId(state, id) {
      state.productId = id;
    }
  },
  actions: {
    fetchProductType(context) {
      return axios.get('admin/producttypes/getproducttype', {
        params: {
          ProductTypeId: context.state.productId
        }
      }).then((res) => {
        context.commit('setName', res.data.result.name);
        context.commit('setPrice', res.data.result.price);
      });
    },
    resetContext(context) {
      context.commit('setName', '');
      context.commit('setPrice', 0);
    },
  },
  namespaced: true
};

export default createEditUser;
